import fgDestinationData from './data/food_groups/destination-data';
import tatDestinationData from './data/take_a_trip/destination-data';
import fgMapData from './data/food_groups/maze-map-data';
import tatMapData from './data/take_a_trip/maze-map-data';
import GameBackground from './game/GameBackground';
import Game from './scenes/Game';
import Intro from './scenes/Intro';
import SelectScreen from './scenes/SelectScreen';
import ReviewScreen from './scenes/ReviewScreen';

export const GameShortNames = {
  fg: 'food_groups',
  fgJr: 'food_groups_jr',
  tat: 'take_a_trip',
  tatJr: 'take_a_trip_jr'
};

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [GameBackground, Intro, SelectScreen, Game, ReviewScreen],

  game: GameShortNames.fg,
  STORAGE_PREFIX: 'food_groups',
  gameModeSoundAtlas: 'gameMode_Sounds',

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: GameBackground.KEY,
  firstScene: Intro.KEY,

  storage: null,
  allLevels: null,
  curLevelIndex: 0,
  playerId: 1,
  gameComplete: false,
  guideNeeded: true,
  firstPlay: true,
  playerDemo: null,

  gameConfigs: {
    [GameShortNames.fg]: {
      GRID_SIZE: 125,
      GAME_HIT_SOUND: 'ant_hit',
      GAME_LIFE_SOUND: '',
      GAME_MOVE_SOUND: 'ant_walking',
      GAME_LEVEL_SOUND: 'level_complete',
      DIFFICULTY: 'hard',
      CUSTOM_PLAYER_OPTIONS: false,
      BLOCK_TYPES: [
        'empty',
        'land',
        'landmark',
        'vertical obstacle',
        'horizontal obstacle',
        'diagonal obstacle'
      ],
      PLAYER_DEMO_NAME: 'Ant',
      BTN_TXT_COLOR: 0x662C05,
      GAME_TITLE: 'Food Groups',
      destinationData: fgDestinationData.destinations,
      mapData: fgMapData
    },

    [GameShortNames.fgJr]: {
      GRID_SIZE: 125,
      GAME_HIT_SOUND: 'ant_hit',
      GAME_LIFE_SOUND: '',
      GAME_MOVE_SOUND: 'ant_walking',
      GAME_LEVEL_SOUND: 'level_complete',
      DIFFICULTY: 'easy',
      CUSTOM_PLAYER_OPTIONS: false,
      BLOCK_TYPES: [
        'empty',
        'land',
        'landmark',
        'vertical obstacle',
        'horizontal obstacle',
        'diagonal obstacle'
      ],
      PLAYER_DEMO_NAME: 'Ant',
      BTN_TXT_COLOR: 0x662C05,
      GAME_TITLE: 'Food Groups',
      destinationData: fgDestinationData.destinations,
      mapData: fgMapData
    },

    [GameShortNames.tat]: {
      GRID_SIZE: 125,
      GAME_HIT_SOUND: 'crash',
      GAME_LIFE_SOUND: 'squeal',
      GAME_MOVE_SOUND: 'driving-sound',
      GAME_LEVEL_SOUND: 'beep',
      DIFFICULTY: 'hard',
      TRACK_CLIP: 'tire-tread',
      CUSTOM_PLAYER_OPTIONS: true,
      BLOCK_TYPES: [
        'empty',
        'land',
        'landmark',
        'vertical obstacle',
        'horizontal obstacle',
        'diagonal obstacle'
      ],
      PLAYER_DEMO_NAME: 'title-car',
      BTN_TXT_COLOR: 0xFFFFFF,
      GAME_TITLE: 'Take a Trip',
      destinationData: tatDestinationData.destinations,
      mapData: tatMapData
    },

    [GameShortNames.tatJr]: {
      GRID_SIZE: 125,
      GAME_HIT_SOUND: 'crash',
      GAME_LIFE_SOUND: 'squeal',
      GAME_MOVE_SOUND: 'driving-sound',
      GAME_LEVEL_SOUND: 'beep',
      DIFFICULTY: 'easy',
      TRACK_CLIP: 'tire-tread',
      CUSTOM_PLAYER_OPTIONS: true,
      BLOCK_TYPES: [
        'empty',
        'land',
        'landmark',
        'vertical obstacle',
        'horizontal obstacle',
        'diagonal obstacle'
      ],
      PLAYER_DEMO_NAME: 'title-car',
      BTN_TXT_COLOR: 0xFFFFFF,
      GAME_TITLE: 'Take a Trip',
      destinationData: tatDestinationData.destinations,
      mapData: tatMapData
    },
  }
};
